<template>
  <PageBase title="Email gegevens" :show-left-button="true">
    <div class="text-sm">Op welk emailadres wilt u het Programma van Eisen ontvangen?</div>
    <div class="flex gap-1">
      <label
        class="text-sm mt-1 flex-1/6"
      >
        Naam aanvrager:
      </label>
      <div class="flex-5/6">
        <input class="rounded-sm p-1 pl-3 text-sm w-full"
        :class="!store.registrationData.ontvangerNaam && errorsShown ? 'border-red-400 border-2' : 'border-slate-300 border'"
        type="text"
        name="name"
        v-model="store.registrationData.ontvangerNaam"
        />
      </div>
    </div>
    <div class="flex gap-1">
      <label
        class="text-sm mt-1 flex-1/6"
      >
        Emailadres:
      </label>
      <div class="flex-5/6">
        <input class="rounded-sm p-1 pl-3 text-sm w-full"
        :class="!store.registrationData.email && errorsShown ? 'border-red-400 border-2' : 'border-slate-300 border'"
        type="email"
        name="email"
        v-model="store.registrationData.email"
        />
      </div>
    </div>

    <div class="borde rounded-lg p-4 bg-slate-100 mt-4">
      <div class="font-bold mb-3">Samenvatting</div>
      <div class="flex gap-1 mb-2 ml-4">
        <label
          class="text-sm font-semibold flex-1/7"
        >
          Gegevens
        </label>
        <div class="flex-6/7">
          <div class="flex flex-col">
            <div class="flex text-sm gap-2">
              <div class="italic">Naam:</div>
              <div>{{ store.registrationData.naam }}</div>
            </div>
            <div class="flex text-sm gap-2">
              <div class="italic">Adres:</div>
              <div>{{ store.registrationData.adres }}</div>
            </div>
            <div class="flex text-sm gap-2">
              <div class="italic">Plaats:</div>
              <div>{{ store.registrationData.plaats }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-1 mb-2 pt-2 ml-4 border-t border-t-slate-200">
        <label
          class="text-sm font-semibold flex-1/7"
        >
          Type
        </label>
        <div class="flex-6/7">
          <div class="flex flex-col">
            <div class="flex text-sm gap-2">
              <div class="italic">Schooltype:</div>
              <div>{{ store.registrationData.schoolType }}{{ (store.registrationData.schoolTypeAdditional.length > 0 ? ',' : '') }}</div>
              <div v-for="(type, i) in store.registrationData.schoolTypeAdditional" :key="type">{{ type }}{{ (i < store.registrationData.schoolTypeAdditional.length - 1 ? ',' : '') }}</div>
            </div>
            <div class="flex text-sm gap-2">
              <div class="italic">Opgave:</div>
              <div>{{ store.registrationData.opgave }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-1 mb-4 pt-2 ml-4 border-t border-t-slate-200">
        <label
          class="text-sm font-semibold mt-1 flex-1/7"
        >
          Thema's
        </label>
        <div class="flex-6/7">
          <div class="flex flex-col">
            <div class="flex flex-col text-sm" v-if="list.length > 0">
              <div v-for="thema in list" :key="thema">{{ thema }}</div>
            </div>
            <div class="text-sm italic" v-else>Geen geselecteerd</div>
          </div>
        </div>
      </div>
    </div>

    <template #rightButton>
      <BlueButton mode="text" text="Afronden" css="w-40 text-center !bg-green-700" :class="!valid && '!opacity-60 !hover:opacity-60 !cursor-default'" @click="sendEmail" />
    </template>
  </PageBase>
</template>

<script setup lang="ts">
import BlueButton from '@/components/BlueButton.vue';
import PageBase from '@/views/pages/PageBase.vue';
import { useRegistrationStore } from '@/stores/registration'
import { computed, ref } from 'vue';
const emit = defineEmits(['sendEmail'])
const store = useRegistrationStore()

const errorsShown = ref(false)
const valid = computed(() => {
  return store.registrationData.email.length > 0 && store.registrationData.ontvangerNaam.length > 0
})

const list = computed(() => {
  const list = [] as string[]
    if (store.registrationData.prioriteringsThemas.installatiearm) {
      list.push('Installatiearm')
    }
    if (store.registrationData.prioriteringsThemas.milieu) {
      list.push('Milieu impact')
    }
    if (store.registrationData.prioriteringsThemas.horizontaleUitbreiding) {
      list.push('Horizontale uitbreidbaarheid')
    }
    if (store.registrationData.prioriteringsThemas.verticaleUitbreiding) {
      list.push('Verticale uitbreidbaarheid')

    }
    if (store.registrationData.prioriteringsThemas.waardebehoud) {
      list.push('Waardebehoud')
    }
    return list
})

function sendEmail() {
  if (!valid.value) {
    errorsShown.value = true
  } else {
    const email = {
      email: store.registrationData.email,
      ontvangerNaam: store.registrationData.ontvangerNaam,
      naam: store.registrationData.naam,
      opgave: store.registrationData.opgave,
      adres: store.registrationData.adres,
      plaats: store.registrationData.plaats,
      schoolType: [] as string[],
      thema: list.value
    }

    const types = [] as string[]
    if (store.registrationData.schoolType) {
      types.push(store.registrationData.schoolType)
    }
    if (store.registrationData.schoolTypeAdditional) {
      types.push(...store.registrationData.schoolTypeAdditional)
    }

    email.schoolType = types

    emit('sendEmail', email)
  }
}

</script>
